import { MemberDetail } from '../../../components/Member';

export function Member() {
  return <MemberDetail />;
}
